<template>
<div id="hdr">
  <RwvHeader />
  <router-view />
  <RwvFooter />
</div>
</template>

<script>
import RwvHeader from "@/components/TheHeader";
import RwvFooter from "@/components/TheFooter";

export default {
  name: 'app',
  components: {
    RwvHeader,
    RwvFooter,

    },
    async created() {
//    console.log("App");
  }
};
</script>

<style>

</style>
